<div class="d-flex align-items-center">
    <!-- #region Facility Select Btn + Dropdown -->
    @if (
        infoService.isFacilitySelectOpen() 
        && !isLoadingFacilities()
    ) {
        <p-select 
            #facilitySelect
            class="mr-2"
            [style.width.px]="200"
            appendTo="body"
            filter="true"
            filterBy="text"
            showClear="true"
            (onHide)="infoService.isFacilitySelectOpen.set(false)"
            [(ngModel)]="selFacilityId"
            (ngModelChange)="saveFacility()"
            [options]="facilities()"
            optionLabel="text"
            optionValue="value"
            placeholder="Facility..."
            filterPlaceholder="Search facilities..."
            [pt]="{
                header: { class: 'bg-secondary text-white' }
            }"
        >
            <ng-template #header>
                <span class="px-3 pt-3 pb-2 d-flex flex-row align-items-center justify-content-center bg-secondary text-white">
                    <i class="pi pi-building mr-2"></i>
                    <h5> Select your facility from the list below.</h5>
                </span>
            </ng-template>
        </p-select>
    } @else {
        <p-button 
            (click)="infoService.openSelect()"
            [disabled]="isLoadingFacilities()"
            [severity]="infoService.userFacility() 
                ? null
                : 'danger' "
            class="pi mr-2 facility-btn rounded"
            [class.highlight]="highlightBtn()"
            raised
            [icon]="isLoadingFacilities() 
                ? 'pi-spin pi-spinner' 
                : infoService.userFacility() 
                    ? 'pi-building'
                    : 'pi-exclamation-triangle'"
            [label]="facilityLabel()"
        />
    }
    <!-- #endregion -->

    <p-button 
        (click)="userInfoPO.toggle($event)"
        rounded
        raised
        [label]="userInitials()"
        [dt]="userBtnDt()"
    />

    <p-popover #userInfoPO
        focusOnShow="false"
        (onHide)="showColor.set(false)"
        [dt]="popoverDt()"
    >
        <!-- #region User Menu Options -->
        <div class="user-info-container">
            @for(item of routeItems(); track item.label) {
                <pcg-link 
                    class="w-100"
                    (click)="userInfoPO.hide()"
                    [href]="item.href"
                >
                    <p-button 
                        size="small"
                        class="w-100"
                        styleClass="w-100"
                        [label]="item.label"
                        [icon]="'pi ' + item.icon"
                        [severity]="item.severity"
                        [dt]="item.dt"
                        raised
                    />
                </pcg-link>
            }  
            
            <p-button  
                size="small"
                (click)="logoutService.logout(user().id); userInfoPO.hide()"
                fluid               
                raised     
                label="Logout"
                icon="pi pi-sign-out"
                severity="danger"
            />

            <p-button  
                size="small"
                (click)="showColor.set(!showColor())"
                fluid               
                label="Color"
                icon="pi pi-palette"
                [dt]="userBtnDt()"
            />

            @if (showColor()) {
                <p-colorpicker 
                    [inline]="true"
                    [(ngModel)]="infoService.userColor"
                />
            }
        </div>
        <!-- #endregion -->
    </p-popover>
</div>

<!-- #region Facility Select Modal -->
<p-dialog
    [header]="infoService.modalReason() === 'daily'
        ? 'Where do you want to work today?'
        : 'Facility Select'"
    (onHide)="closeModal()"
    [(visible)]="infoService.isModalOpen"
    [style.width.vw]="25"
    [modal]="true"
    draggable="false"
    resizable="false"
    dismissableMask="true"
>
    <div class="d-flex flex-column">
        @if (
            user()?.isRxUser
            && infoService.userFacility() 
            && !infoService.userFacility()?.supportsRxRequests
        ) {
            <small class="text-danger">
                <i class="pi pi-exclamation-triangle"></i>
                Warning: This facility DOES NOT support Rx Requests.
            </small>
        }
        @if (infoService.modalReason() === 'daily') {
            <small class="text-muted">Confirm the facility you are working at today, or choose another.</small>
        } @else {
            <small class="text-muted">Please select a facility. This facility will be used for things like Rx Requests.</small>
        }
        @if (isLoadingFacilities()) {
            <p-skeleton 
                height="40px"
                width="25vw"
            />
        } @else {
            <p-select   
                #modalFacilitySelect      
                class="mr-2"
                [style.width.vw]="25"
                appendTo="body"
                filter="true"
                filterBy="text"
                showClear="true"
                [(ngModel)]="selFacilityId"
                (ngModelChange)="saveFacility(); closeModal()"
                [options]="facilities()"
                optionLabel="text"
                optionValue="value"
                placeholder="Facility..."
            />

            <!-- Keeping the saved facility just closes the modal; nothing is saved -->
            @if (
                infoService.modalReason() === 'daily'
                && infoService.userFacility()
            ) {
                <p-button
                    class="mt-3 align-self-end"
                    (click)="closeModal()"
                    icon="pi pi-check"
                    [label]="'Keep ' + $safeNavigationMigration(infoService.userFacility()?.name)"
                    raised
                />
            }
        }
    </div>
</p-dialog>
<!-- #endregion -->